import React, { Component,useState } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { toast } from 'react-toastify';
import { Typography, Box,Button ,Modal} from '@material-ui/core';
import InputText from '../../commonModules/interface/form-input-inline';

import { createAccount } from '../../../../../jsx/actions/accountAction'


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

function AccountList(props){

    const [open, setOpen] = useState(false);
    const [accountName, setAccountName] = useState("");
    const [username, setUsername] = useState("");
    const [country, setCountry] = useState("");
    const [email, setEmail] = useState("");
    const [pwd, setPwd] = useState("");
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleCreate = async () =>{
        console.log("[INFO],",accountName,",",country,",",email)
        if (accountName ==="" || country === "" || email === "" || pwd === ""){
            toast.error("Info is missing")
        }
        //Send to back-end
        const resp = await props.createAccount({accountName:accountName, country:country,email:email,pwd:pwd,username:username});
			// resp must contain list of linked account
			if (resp === "ook"){
				console.log("Info => ok")
                toast.info("Account is created")
                handleClose()
            }else{
                toast.error("Something wrong")
            }
    }

    return (
        <Box p={2}>
            <Typography variant="h5">AccountList</Typography>
            <Button onClick={handleOpen}>Add Account</Button>
            <Modal
                keepMounted
                open={open}
                onClose={handleClose}
                aria-labelledby="keep-mounted-modal-title"
                aria-describedby="keep-mounted-modal-description"
            >
                <Box sx={style}>
                <Typography id="keep-mounted-modal-title" variant="h6" component="h2">
                    Ajouter Compte
                </Typography>
                <Typography id="keep-mounted-modal-description" sx={{ mt: 2 }}>
                    Entrer les informations
                </Typography>
                <InputText
                    value={country}
                    onChange={(e) => {setCountry(e.target.value)}}
                    required
                    name="comments"
                    label="Pays"
                    rows={1}
                />
                <InputText
                    value={username}
                    onChange={(e) => {setUsername(e.target.value)}}
                    required
                    name="comments"
                    label="Nom Administrateur"
                    rows={1}
                />
                <InputText
                    value={accountName}
                    onChange={(e) => {setAccountName(e.target.value)}}
                    required
                    name="comments"
                    label="Nom Compte"
                    rows={1}
                />
                <InputText
                    value={email}
                    onChange={(e) => {setEmail(e.target.value)}}
                    required
                    name="comments"
                    label="Email"
                    rows={1}
                />
                <InputText
                    value={pwd}
                    onChange={(e) => {setPwd(e.target.value)}}
                    required
                    type="password"
                    name="comments"
                    label="password"
                    rows={1}
                />
                <Button onClick={handleCreate}>Create Account</Button>
                </Box>
            </Modal>
        </Box>
    );
};
function mapStateToProps(state){
    return {

    }
  }
  
  function mapDispatchToProps(dispatch){  
      return bindActionCreators({
        createAccount
      }, dispatch)
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(AccountList);
